import { pdf, type DocumentProps } from '@react-pdf/renderer';
import React from 'react';
import LogbookReport from './LogbookReport';
import { ReportConfig } from './types';

export type { ReportConfig, LogbookEntry, ReportBranding, ReportFooter } from './types';

// Duty log exports are an operational record; every generated PDF carries the
// same notice. Defined once so the wording cannot drift between export paths.
export const DEFAULT_REPORT_FOOTER = {
  confidentialityText: 'Confidential — internal use only.',
  showPageNumbers: true,
} as const;

export async function generateLogbookPdf(config: ReportConfig): Promise<Blob> {
  const element = React.createElement(LogbookReport, { config }) as React.ReactElement<DocumentProps>;
  const blob = await pdf(element).toBlob();
  return blob;
}

export function downloadPdf(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
